// This class implementes a SVG gauge that supports daily streaks.
// Params:
// max    = maximum value for the gauge
// value  = current value
// streak = number of the streak. (optional)
window.StreakGauge = function(domContainer) {
  this.domContainer = domContainer;
  this.max    = domContainer.data('max');
  this.value  = domContainer.data('value');
  this.streak = domContainer.data('streak');

  this.gauge = new Gauge(domContainer[0], {
    max: this.max,
    showValue: false,
    dialStartAngle: 120,
    dialEndAngle: 60
   })

  this.setAnimated = function(){
    this.updateDisplay();
    this.gauge.setValueAnimated(this.value, 1);
  }

  this.updateDisplay = function(){
    // show daily goal icon if reached
    if(this.value >= this.max) {
      this.domContainer
        .find('.gauge-container__label-section__max-reached-icon--disabled')
        .hide()
        .attr('class', 'gauge-container__label-section__max-reached-icon')
        .fadeIn('slow');
    };

    // show streak interface if we receive a streak value
    if(this.streak || this.streak == 0) {
      this.domContainer
        .find('.gauge-container__streak-section--disabled')
        .attr('class', 'gauge-container__streak-section');
    };
  }
}
